// src/utils/rem.js
import $ from 'jquery';

function setRem() {
  var window_width = $(window).width();
  var rule_num = window_width * 18 / 480;

  if (window_width > 768) {
    $('html').css('font-size', '20px');
  } else {
    $('html').css('font-size', rule_num + 'px');
  }
}

function initRem() {
  // 初始化
  setRem();

  // 监听窗口变化
  $(window).on('resize', function () {
    setRem();
  });
}

export default initRem;



// WEBPACK FOOTER //
// ./src/utils/rem.js